import axios from "axios";
import {RESET_PASSWORD, SEND_RESET_LINK} from "../routes";

export default {
    async sendResetLink(data, options = {}) {
        return await axios.post(SEND_RESET_LINK, data, options);
    },
    async resetPassword(data, options = {}) {
        return await axios.post(RESET_PASSWORD, data, options);
    }
}
